import { pclnExpt } from '../../../../common/fly-experimentation/fly-experimentation'
import {
  PCLN_GRAPH_URL,
  GRAPH_CDN_PROD,
  GRAPH_CDN_QA,
  GRAPH_CDN_SETI,
} from './constants'

const getEnv = () =>
  typeof window === 'undefined' ? '' : window.PCLN_BOOTSTRAP_DATA?.BOOTSTRAP_ENV

const isProd = () => ['pre-prod', 'prod'].includes(getEnv())

const getGraphCdnURL = () => (isProd() ? GRAPH_CDN_PROD : GRAPH_CDN_QA)

const isEligibleAPI = operationName => {
  const setiName = GRAPH_CDN_SETI[operationName]
  if (setiName) {
    pclnExpt.fireImpression(setiName)
    return pclnExpt.isVariant(setiName)
  }
  return false
}

const getURL = operationName =>
  isEligibleAPI(operationName) ? getGraphCdnURL() : PCLN_GRAPH_URL

export { getURL }
